import React from "react";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  DataTable,
  SearchPropTypes,
  CompanyName
} from "MODULES/shared/components";
import { truncate } from "lodash";
import Status from "./Status";
import RepairStationStatus from "./RepairStationStatus";
import VendorStatus from "./VendorStatus";

function renderRow(r, pushHistory) {
  const address = r.primary_physical_address;

  return (
    <tr
      key={r.id}
      className="clickable"
      onClick={() => pushHistory(`/companies/${r.uuid}`)}
    >
      <td>
        <CompanyName company={r} />
      </td>
      <td>{r.code}</td>
      <td>
        {address && `${address.city}, ${address.state}, ${address.country}`}
      </td>
      <td>
        <Status status={r.status} />
        &nbsp;
        <VendorStatus status={r.vendor_status} />
        &nbsp;
        <RepairStationStatus status={r.repair_station_status} />
      </td>
      <td>{r.region}</td>
      <td>{truncate(r.fleet, 25)}</td>
      <td>{r.phone}</td>
      <td className="text-center">{r.demerits}</td>
    </tr>
  );
}

export function Table({ results, pushHistory, isLoading }) {
  return (
    <DataTable loading={isLoading}>
      <DataTable.Head>
        <th>Name</th>
        <th>Code</th>
        <th>Address</th>
        <th>Status</th>
        <th>Region</th>
        <th>Fleet</th>
        <th>Company Phone</th>
        <th className="text-center">Active Demerits</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(r => renderRow(r, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/companies/components/Search/Table.jsx